import React from 'react';
import { Container, Row, Col, Card, Button, Image, ListGroup, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Data = () => {
  return (
    <Container className="py-5">
      {/* En-tête */}
      <Row className="mb-5 text-center">
        <Col>
          <h1 className="fw-bold mb-3">Données extraites d'une analyse de la Parcelle de Blé à Lehaucourt</h1>
          <p className="lead">20.55 hectares - Saint-Quentin, Aisne (02420)</p>
          <Badge bg="success" className="fs-6 mt-2">Analyse du 12/04/2025</Badge>
        </Col>
      </Row>

      {/* Section 1 - Données techniques */}
      <Row className="mb-5">
        <Col lg={6} className="mb-4">
          <Card className="h-100 shadow">
            <Card.Header className="bg-success text-white">
              <h2 className="h5 mb-0">Analyse physico-chimique du sol</h2>
            </Card.Header>
            <Card.Body>
              <Image src="/images/sateco_analyse.png" fluid rounded className="mb-4 border" />
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <strong>Profondeur d'analyse :</strong> 30 cm (horizon cultural)
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>pH :</strong> 7.64 - Sol neutre (optimal pour le blé)
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Carbone organique :</strong> 3.77 kg/m² - Taux satisfaisant
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>CEC :</strong> 15.71 cmol/kg - Bonne capacité de rétention
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Texture :</strong> Limono-argileuse (61.95% limon, 30.08% argile)
                </ListGroup.Item>
                <ListGroup.Item className="bg-light">
                  <strong>Impact économique :</strong> La texture fine permet une bonne rétention d'eau, réduisant les besoins en irrigation.
                </ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6} className="mb-4">
          <Card className="h-100 shadow">
            <Card.Header className="bg-success text-white">
              <h2 className="h5 mb-0">Paramètres environnementaux</h2>
            </Card.Header>
            <Card.Body>
              <Image src="/images/sateco_analyse2.png" fluid rounded className="mb-4 border" />
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <strong>Température sol/air :</strong> 7.54°C / 11.72°C
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Humidité du sol :</strong> 37.65% - Niveau correct
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Pluviométrie :</strong> 878 mm/an - Suffisante
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Salinité :</strong> Légèrement salin - Surveillance requise
                </ListGroup.Item>
                <ListGroup.Item className="bg-light">
                  <strong>Impact économique :</strong> Ces données permettent d'ajuster l'irrigation pour économiser ~15% d'eau.
                </ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Section 2 - Cartes de fertilité */}
      <Row className="mb-5">
        <Col>
          <Card className="shadow">
            <Card.Header className="bg-success text-white">
              <h2 className="h5 mb-0">Cartographie de précision</h2>
            </Card.Header>
            <Card.Body>
              <Row>
                {/* Carte Azote */}
                <Col md={4} className="mb-4">
                  <Card className="h-100">
                    <Image src="/images/sateco_carteN.png" fluid className="border-bottom" />
                    <Card.Body>
                      <h3 className="h6">Carences en Azote (N)</h3>
                      <p>
                        Zones orange : carence sévère (besoin 50kg N/ha)
                      </p>
                      <p className="text-primary">
                        <strong>Économie :</strong> Apport ciblé seulement sur 35% de la parcelle
                      </p>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Carte Phosphore */}
                <Col md={4} className="mb-4">
                  <Card className="h-100">
                    <Image src="/images/sateco_carteK.png" fluid className="border-bottom" />
                    <Card.Body>
                      <h3 className="h6">Carences en Potassium (K)</h3>
                      <p>
                        Marqueurs gris : carences localisées
                      </p>
                      <p className="text-primary">
                        <strong>Gain :</strong> Réduction de 60% des apports par rapport à un épandage uniforme
                      </p>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Carte Eau */}
                <Col md={4} className="mb-4">
                  <Card className="h-100">
                    <Image src="/images/sateco_carteWater.png" fluid className="border-bottom" />
                    <Card.Body>
                      <h3 className="h6">Faible teneur en eau</h3>
                      <p>
                        Marqueurs violets : stress hydrique
                       
                      </p>
                      <p className="text-primary">
                        <strong>Optimisation :</strong> Irrigation ciblée sur 25% de la surface
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <div className="alert alert-success mt-4">
                <h3 className="h5">Bon à savoir</h3>
                <p>
                  Cette parcelle présente des niveaux <strong>suffisants en phosphore, magnésium et calcium</strong>.
                  <br />
                  <strong>Recommandation :</strong> Aucun apport nécessaire pour ces éléments cette saison.
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Section 3 - Avantages économiques */}
      <Row className="mb-5">
        <Col>
          <Card className="border-success shadow">
            <Card.Header className="bg-success text-white">
              <h2 className="h5 mb-0">Bénéfices pour votre exploitation</h2>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={4} className="mb-3">
                  <div className="text-center p-3 h-100 bg-light rounded">
                  { /* <Image src="/images/icon-rendement.png" width={60} className="mb-3" /> */}
                    <h3 className="h5">Économies réalisées</h3>
                    <ul className="text-start">
                      <li>40% d'engrais azoté en moins</li>
                      <li>30% de réduction des coûts en phosphore</li>
                      <li>15% d'économie d'eau</li>
                    </ul>
                  </div>
                </Col>
                <Col md={4} className="mb-3">
                  <div className="text-center p-3 h-100 bg-light rounded">
                   { /* <Image src="/images/icon-rendement.png" width={60} className="mb-3" /> */}
                    <h3 className="h5">Gain de productivité</h3>
                    <ul className="text-start">
                      <li>Meilleure uniformité des cultures</li>
                      <li>Réduction du stress hydrique</li>
                      <li>Optimisation des rendements</li>
                    </ul>
                  </div>
                </Col>
                <Col md={4} className="mb-3">
                  <div className="text-center p-3 h-100 bg-light rounded">
                  { /* <Image src="/images/icon-rendement.png" width={60} className="mb-3" /> */}
                    <h3 className="h5">Avantage écologique</h3>
                    <ul className="text-start">
                      <li>Réduction de l'empreinte carbone</li>
                      <li>Préservation des sols</li>
                      <li>Moins de ruissellement polluant</li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* CTA */}
      <Row className="mb-5">
        <Col className="text-center">
          <div className="p-5 bg-light rounded">
            <h2 className="h3 mb-4">Cette technologie change la façon de travailler</h2>
            <p className="lead mb-4">
              Nos cartes de fertilité dynamiques vous permettent d'éviter les apports uniformes et de cibler précisément les zones carencées.
            </p>
            <Button 
              as={Link} 
              to="/devis-gratuit" 
              variant="success" 
              size="lg" 
              className="rounded-pill px-4 py-2"
            >
              <span className="fw-bold">Demander un devis gratuit</span>
            </Button>
            <p className="small mt-3">
              Obtenez votre analyse personnalisée sous 48h
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Data;